import { useEffect } from 'react'

import { useDataBoxSelector } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  defaultSubsidiesSumsAndKitsDataReceiver,
  subsidyTypeFilterSelection,
  subsidiesSumsAndKitsFilter,
  subsidiesSumsAndKitsFilterSelection,
  orgsFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const SumsAndKitsFilter = ({ id, pending }: Props) => {
  const orgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const subsidyType = useDataBoxSelector(
    subsidyTypeFilterSelection,
    () => subsidyTypeFilterSelection.data,
  )
  const visible = orgs.length === 1

  useEffect(() => {
    subsidiesSumsAndKitsFilterSelection.resetToDefault()
    if (!visible) {
      subsidiesSumsAndKitsFilter.resetToDefault()
      return
    }

    subsidiesSumsAndKitsFilter.setStatusPending()
    defaultSubsidiesSumsAndKitsDataReceiver(orgs[0]).then((items) => {
      subsidiesSumsAndKitsFilter.updateData(() => items)
      subsidiesSumsAndKitsFilter.setStatusReady()
    })
  }, [orgs, visible])

  if (!visible) return null
  const common = subsidyType.length === 1 && subsidyType[0] === 'common'
  return (
    <PlainItemsSelectorBox
      id={id}
      label={common ? 'Комплекты справок' : 'Сумма или комплект справки'}
      header={common ? 'Выбор комплектов справок' : 'Выбор сумм или комплекта справки'}
      dataBoxData={subsidiesSumsAndKitsFilter}
      dataBoxSelection={subsidiesSumsAndKitsFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      multiple
      disabled={pending}
    />
  )
}
